export default "__VITE_ASSET__wh6djiqw__";